import { Grid, makeStyles, Menu } from "@material-ui/core";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { Text, SelectBox, Input, TextArea, Button, Modal } from "sunrise-ui";
import {
  getAllAssignedMachineData,
  getAllUnassignedMachineData,
  putMachineData,
} from "../../redux/reducers/machineReducers";
import { getAllProjectData } from "../../redux/reducers/projectReducers";
import { AppDispatch } from "../../redux/store";
import Loader from "../../utilities/Loader";
import List from "./List";

const useStylesForPopUp = makeStyles({
  customWidth: {
    "& .MuiMenu-list": {
      width: "280px !important",
      border: "1px solid #5F67E0",
      borderRadius: "8px",
    },
  },
});

const AssignMachine = () => {
  const dispatch = useDispatch<AppDispatch>();

  const allProject = useSelector((state: any) => state.PROJECT.allProjectData);
  const allUnassignedMachine = useSelector(
    (state: any) => state.MACHINE.allUnassignedMachineData
  );
  const allAssignedMachine = useSelector(
    (state: any) => state.MACHINE.allAssignedMachineData
  );
  // let masterData = useSelector((state: any) => state.UI.masterData);

  const [projectList, setProjectList] = useState([]);
  const [projectName, setProjectName] = useState("");
  const [projectId, setProjectId] = useState("");
  const [projectIdErr, setProjectIdErr] = useState(false);
  const [unassignedMachines, setUnassignedMachines] = useState([]);
  const [machineName, setMachineName] = useState("");
  const [machineId, setMachineId] = useState("");
  const [machineIdErr, setMachineIdErr] = useState(false);
  const [assignDate, setAssignDate] = useState("");
  const [errAssignDate, setErrAssignDate] = useState(false);
  const [errDescription, setErrDescription] = useState(false);

  const [unassignDate, setUnassignDate] = useState("");
  const [errUnassignDate, setErrUnassignDate] = useState(false);
  const [description, setDescription] = useState("");
  const [dataToDownload, setDataToDownload] = useState([]);

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const classes = useStylesForPopUp();

  const handleAnchorSelect = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setUnassignDate("");
    setErrUnassignDate(false);
    setAnchorEl(null);
    handleCancel();
  };

  const handlePopUpSubmit = () => {
    // if (validateData()) {
    //   setIsLoadingButton(true);

    //   const obj: any = {
    //    unassignDate : unassignDate
    //   }
    if (unassignDate === undefined || unassignDate === "") {
      setErrUnassignDate(true);
    } else {
      handleCall();
      handleMenuClose();
    }

    //   dispatch(
    //     postUpsertMachineDoc({
    //       endPoint: "machine/document",
    //       data: obj,
    //     })
    //   ).then((res) => { setIsLoadingButton(false); });
    // handleMenuClose();
    //   //  --went to modal yes button handler--
    // }
  };

  const changeResetValue = () => {};

  //-----List Items---------
  const fields = [
    { header: "Project Name", value: "projectName", search: true },
    { header: "Machine Detail", value: "machineDetail", search: true },
    { header: "Assigned Date", value: "assignDate", format: "date" },
    { header: "Unassigned Date", value: "unassignDate", format: "date" },
    { header: "Description", value: "description" },
    {
      header: "Action/Status",
      action: function (obj: any) {
        return (
          <Grid item xs={2}>
            {obj.isAssigned && (
              <div className="action_buttons_box d-flex v-center">
                <Button
                  type="button"
                  size="small"
                  isRounded={true}
                  category="warning"
                  onClick={(e: any) => {
                    handleUnassign(obj);
                    handleAnchorSelect(e);
                  }}
                  className="f14"
                >
                  {actionLoading &&
                  handleCallData.action === "UNASSIGN" &&
                  obj.id === handleCallData?.machine ? (
                    <Loader
                      color="#fff"
                      loading={actionLoading}
                      size={8}
                      height="auto"
                    />
                  ) : (
                    "Unassign"
                  )}
                </Button>
              </div>
            )}
            {!obj.isAssigned && (
              <Text
                type="normal"
                fonts="normal"
                fontSize={14}
                className="mb0 mt0"
              >
                <span style={{ color: "#961B01" }} className="fw500">
                  Unassigned!
                </span>
              </Text>
            )}
          </Grid>
        );
      },
    },
  ];

  //-----modal state--------
  const [open, setOpen] = useState(false);
  const [modalText, setModalText] = useState("");
  const [handleCallData, setHandleCallData] = useState({
    machine: "",
    action: "",
    project: "",
    assignmentDescription: "",
    assignedOn: "",
    unassignDate: "",
  });

  //-------For displaying loader---------
  const [isLoading, setIsLoading] = useState(false);
  const [actionLoading, setActionLoading] = useState(false);

  useEffect(() => {
    dispatch(
      getAllProjectData({
        endPoint: `project/get-all-projects`,
      })
    );
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    // eslint-disable-next-line
    // masterData = {};
    // get list of all the projects available
    let arr2: any = [];
    if (allProject !== undefined) {
      let arr: any = [];
      arr = allProject;
      if (arr.length > 0) {
        arr.forEach((val: any) => {
          arr2.push(val.projectName);
        });
        setProjectList(arr2);
      }
    }
  }, [allProject]);

  //set id method
  const setObjectId = (
    list: Array<any>,
    index: any,
    setMethod: Function,
    key: string
  ) => {
    setMethod(list[index][key]);
  };

  useEffect(() => {
    setIsLoading(true);
    dispatch(
      getAllAssignedMachineData({
        endPoint: `machine/assign-history`,
      })
    ).then((res) => setIsLoading(false));
    dispatch(
      getAllUnassignedMachineData({
        endPoint: `machine/list?status=UNASSIGNED`,
      })
    );
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    // eslint-disable-next-line
    // masterData = {};
    // get list of all the projects available
    let arr2: any = [];
    if (allUnassignedMachine !== undefined) {
      let arr: any = [];
      arr = allUnassignedMachine;
      if (arr.length > 0) {
        arr.forEach((val: any) => {
          // arr2.push(val.number);
          arr2.push(val.machineDetail);
        });
        setUnassignedMachines(arr2);
      }
    }
  }, [allUnassignedMachine]);

  const handleAssign = () => {
    if (validateData()) {
      const obj = {
        machine: machineId,
        action: "ASSIGN",
        project: projectId,
        assignmentDescription: description,
        assignedOn: assignDate,
        unassignDate: "",
      };
      setHandleCallData(obj);
      handleModal("ASSIGN", machineName);
    }
  };

  const handleUnassign = (machineObj: any) => {
    const obj = {
      machine: machineObj.machine,
      assignedOn: machineObj.assignDate,
      action: "UNASSIGN",
    };
    setHandleCallData({ ...handleCallData, ...obj });
    // handleModal("UNASSIGN", machineObj.number);
  };

  const handleCancel = () => {
    setProjectId("");
    setProjectName("");
    setMachineId("");
    setMachineName("");
    setAssignDate("");
    setDescription("");
    setProjectIdErr(false);
    setMachineIdErr(false);
    setErrAssignDate(false);
    setErrDescription(false);
  };
  // console.log("desc",description.length)
  const validateData = () => {
    let passed = true;
    if (projectId === undefined || projectId === "") {
      setProjectIdErr(true);
      passed = false;
    }
    if (machineId === undefined || machineId === "") {
      setMachineIdErr(true);
      passed = false;
    }
    if (assignDate === undefined || assignDate === "") {
      setErrAssignDate(true);
      passed = false;
    }
    if (description.length > 100 || description.length < 1) {
      setErrDescription(true);
      passed = false;
    }
    return passed;
  };

  //------modal handler
  const handleModal = (type: string, machineName: string) => {
    setOpen(true);
    type === "ASSIGN"
      ? setModalText(
          `Are you sure you want to assign this machine (${machineName})?`
        )
      : setModalText(
          `Are you sure you want to unassign this machine (${machineName})?`
        );
  };
  //----modal YES button handler
  const handleCall = () => {
    const DATE = new Date(handleCallData.assignedOn);
    const date = DATE.getDate();
    const month = DATE.getMonth();
    const year = DATE.getFullYear();
    const assignDate = new Date();
    assignDate.setDate(date);
    assignDate.setMonth(month);
    assignDate.setFullYear(year);

    setActionLoading(true);
    dispatch(
      putMachineData({
        endPoint: "machine",
        data: {
          ...handleCallData,
          assignedOn: assignDate,
        },
      })
    ).then((res) => {
      setActionLoading(false);
      dispatch(
        getAllAssignedMachineData({ endPoint: `machine/assign-history` })
      ).then((res) => setIsLoading(false));
      dispatch(
        getAllUnassignedMachineData({
          endPoint: `machine/list?status=UNASSIGNED`,
        })
      );
    });
    // setTimeout(function () {

    // }, 500);
    setOpen(false);
    handleCancel();
  };

  useEffect(() => {
    const downloadData: any = allAssignedMachine?.map((val: any) => {
      return {
        "Project Name": val?.projectName === null ? "" : val?.projectName,
        "Machine Detail": val?.machineDetail === null ? "" : val?.machineDetail,
        "Assigned Date": val?.assignDate === null ? "" : val?.assignDate,
        "Unassigned Date": val?.unassignDate === null ? "" : val?.unassignDate,
        "Description": val?.description === null ? "" : val?.description,
        "Status": val?.isAssigned === null ? "" : val?.isAssigned ? "Assigned" : "Unassigned",
      };
    });
    setDataToDownload(downloadData);
  }, [allAssignedMachine]);

  return (
    <>
      {isLoading ? (
        <Loader
          color="#5f67e0"
          loading={isLoading}
          size={20}
          height="80vh"
          style={{ width: "inherit" }}
        />
      ) : (
        <Grid container className="mt15">
          <Grid
            container
            className="bg--white box--shadow m0 mt15 p1"
            spacing={2}
          >
            <Grid item xs={12} container>
              <Grid item xs={3}>
                <Text
                  type="normal"
                  fonts="normal"
                  fontSize={18}
                  className="mb0 mt0"
                >
                  <span className="fw500">Assign Machine</span>
                </Text>
              </Grid>
            </Grid>
            <Grid item xs={12} container spacing={2}>
              <Grid item xs={3}>
                <Text
                  type="normal"
                  fonts="normal"
                  fontSize={16}
                  className="mb0 mt0"
                >
                  <span className="fw500">Select Project*</span>
                </Text>
                <SelectBox
                  data={projectList}
                  placeHolder="Select Project"
                  defaultVal={projectName}
                  resetVal={projectName === "" ? true : false}
                  changeReset={changeResetValue}
                  onChange={(e) => {
                    setProjectIdErr(false);
                    let target = { ...e };
                    setProjectName(target.target.value);
                    const index = projectList
                      ?.map((item: any) => item)
                      .indexOf(target.target.value);
                    setObjectId(allProject, index, setProjectId, "_id");
                  }}
                  borderColor={projectIdErr ? "danger" : "primary"}
                />
                <Text
                  type={projectIdErr ? "danger" : "normal"}
                  fonts="normal"
                  fontSize={12}
                  className={projectIdErr ? "mb0 mt0" : "d-none"}
                >
                  Please Select a Project
                </Text>
              </Grid>
            </Grid>

            <Grid item xs={12} container spacing={2}>
              <Grid item xs={3}>
                <Text
                  type="normal"
                  fonts="normal"
                  fontSize={16}
                  className="mb0 mt0"
                >
                  <span className="fw500">Select Machine*</span>
                </Text>
                <SelectBox
                  data={unassignedMachines}
                  placeHolder="Select Machine"
                  defaultVal={machineName}
                  resetVal={machineName === "" ? true : false}
                  changeReset={changeResetValue}
                  onChange={(e) => {
                    setMachineIdErr(false);
                    let target = { ...e };
                    setMachineName(target.target.value);
                    const index = unassignedMachines
                      ?.map((item: any) => item)
                      .indexOf(target.target.value);
                    setObjectId(
                      allUnassignedMachine,
                      index,
                      setMachineId,
                      "id"
                    );
                  }}
                  borderColor={machineIdErr ? "danger" : "primary"}
                />
                <Text
                  type={machineIdErr ? "danger" : "normal"}
                  fonts="normal"
                  fontSize={12}
                  className={machineIdErr ? "mb0 mt0" : "d-none"}
                >
                  Please Select a Machine
                </Text>
              </Grid>
              <Grid item xs={3}>
                <Text
                  type="normal"
                  fonts="normal"
                  fontSize={16}
                  className="mb mt0"
                >
                  <span className="fw500">Select Assigning Date*</span>
                </Text>
                <Input
                  color={errAssignDate ? "danger" : "primary"}
                  fonts="normal"
                  placeholder="Enter Here"
                  value={assignDate}
                  type="date"
                  onChange={(e) => {
                    setErrAssignDate(false);
                    setAssignDate(e.target.value);
                  }}
                />
                <Text
                  type={errAssignDate ? "danger" : "normal"}
                  fonts="normal"
                  fontSize={12}
                  className={errAssignDate ? "mb0 mt0 float-right" : "d-none"}
                >
                  Please Enter Machine Assign Date.
                </Text>
              </Grid>
            </Grid>

            <Grid item xs={12} container spacing={2}>
              <Grid item xs={3}>
                <Text
                  type="normal"
                  fonts="normal"
                  fontSize={16}
                  className="mb0 mt1"
                >
                  <span className="fw500">Description*</span>
                </Text>
                <TextArea
                  color={errAssignDate ? "danger" : "primary"}
                  placeholder="Write description here"
                  value={description}
                  onChange={(e) => {
                    setErrDescription(false);
                    setDescription(e.target.value);
                  }}
                />
                <Text
                  type={errDescription ? "danger" : "normal"}
                  fonts="normal"
                  fontSize={12}
                  className={errDescription ? "mb0 mt0 float-right" : "d-none"}
                >
                  Description required within 100 characters.
                </Text>
              </Grid>
            </Grid>

            <Grid item xs={12} container>
              <Grid item className="mt2 ml-1">
                <Button
                  type="button"
                  size="medium"
                  isRounded={true}
                  category="primary"
                  onClick={() => {
                    handleAssign();
                  }}
                  className="submit_button mb1 mt1 mr-1 pl pr"
                >
                  {actionLoading && handleCallData.action === "ASSIGN" ? (
                    <Loader
                      color="#fff"
                      loading={actionLoading}
                      size={8}
                      height="auto"
                    />
                  ) : (
                    "Submit"
                  )}
                </Button>
              </Grid>
              <Grid item className={"mt2 ml-1"}>
                <Button
                  type="button"
                  size="medium"
                  isRounded={true}
                  category="border-only"
                  onClick={() => {
                    handleCancel();
                  }}
                  className="submit_button mb1 mt1 pl pr"
                >
                  Reset
                </Button>
              </Grid>
            </Grid>
          </Grid>
          <Grid container className="mt1">
            {allAssignedMachine && (
              <List
                listData={allAssignedMachine}
                fields={fields}
                title={"List of Assigned Machines"}
                dataToDownload={dataToDownload}
              />
            )}
            {
              /* -------modal---- */
              <Grid item xs={12}>
                <Modal
                  image="modalImage"
                  call={() => {
                    handleCall();
                  }}
                  reset={() => {
                    setOpen(false);
                  }}
                  openModal={open}
                  title={`${modalText}`}
                  showImageModal={false}
                />
              </Grid>
            }
          </Grid>
        </Grid>
      )}

      {/* ------------Popup Menu------ */}
      <Grid item xs={12}>
        <Menu
          id="pileSteps-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
          className={classes.customWidth}
        >
          <Grid container className="p1">
            <Grid item xs={12}>
              <Text
                type="normal"
                fonts="normal"
                fontSize={18}
                className="mb0 mt0"
              >
                <span className="fw500">{`Unassign Machine`}</span>
              </Text>
            </Grid>
            {/* -------Unassigned date field------ */}
            <Grid item xs={12}>
              <Text
                type="normal"
                fonts="normal"
                fontSize={16}
                className="mb mt1"
              >
                <span className="fw500">{`Unassign Date`}</span>
              </Text>
              <Input
                color={errUnassignDate ? "danger" : "primary"}
                fonts="normal"
                placeholder="Enter Here"
                value={unassignDate}
                type="date"
                min={handleCallData.assignedOn.split("T")[0]}
                onChange={(e) => {
                  if (
                    e.target.value?.toString() <
                    handleCallData.assignedOn.split("T")[0]
                  ) {
                    setUnassignDate("");
                    return false;
                  } else {
                    setUnassignDate(e.target.value);
                    setHandleCallData({
                      ...handleCallData,
                      unassignDate: e.target.value,
                    });
                    setErrUnassignDate(false);
                  }
                }}
              />
              <Text
                type={errUnassignDate ? "danger" : "normal"}
                fonts="normal"
                fontSize={12}
                className={errUnassignDate ? "mb0 mt0" : "d-none"}
              >
                Please Select Unassigned Date
              </Text>
            </Grid>
            <Grid container className="mt0" xs={12}>
              <Grid item xs={12}>
                <Grid className="d-flex mt2">
                  <Button
                    type="button"
                    size="medium"
                    isRounded={true}
                    category="border-only"
                    onClick={() => {
                      // handleModal("unassign", row?._id, row);
                      handleMenuClose();
                    }}
                    className="f14 mr-1"
                  >
                    Cancel
                  </Button>
                  <Button
                    type="button"
                    size="medium"
                    isRounded={true}
                    category="primary"
                    onClick={() => {
                      // handleModal("unassign", row?._id, row);
                      handlePopUpSubmit();
                    }}
                    className="f14"
                  >
                    Submit
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Menu>
      </Grid>
    </>
  );
};

export default AssignMachine;
